import { useQuery } from '@tanstack/react-query';
import { DashboardService } from '../services/dashboardService';
import { DashboardDataResponse } from '../types/DashboardData';
import { GetDashboardDataParams } from '../types/DashboardRequests';

interface UseDashboardDataProps {
  dashboardId: string;
  filters?: GetDashboardDataParams;
  enabled?: boolean;
  refreshInterval?: number;
}

export const useDashboardData = ({
  dashboardId,
  filters,
  enabled = true,
  refreshInterval,
}: UseDashboardDataProps) => {
  const {
    data,
    isLoading,
    error,
    refetch,
    isFetching,
  } = useQuery<DashboardDataResponse>({
    queryKey: ['dashboard-data', dashboardId, filters],
    queryFn: () => DashboardService.getDashboardData(dashboardId, filters),
    enabled: enabled && !!dashboardId,
    staleTime: refreshInterval ? refreshInterval * 60 * 1000 : 2 * 60 * 1000,
    refetchInterval: refreshInterval ? refreshInterval * 60 * 1000 : false,
  });

  return {
    data: data?.data?.data,
    dashboardInfo: data?.data?.dashboard,
    isLoading,
    error,
    refetch,
    isFetching,
  };
};
